<template>
  <div class="grid-view">
    <div class="main-content account-set">
      <div class="section operations">
        <div class="filters">
          <el-button type="primary" @click="addForExistAccountSet">{{ $t('CargoMsg.Cargo_CopyFromExisting') }}</el-button>
          <el-button type="primary" @click="showEditDialog(false)">{{ $t('common.btn.new') }}</el-button>
          <el-button :disabled="!cellSelected" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.edit') }}</el-button>
          <el-button type="primary" @click="refreshHandler">{{ $t('common.btn.refresh') }}</el-button>
          <el-button :disabled="!cellSelected" type="danger" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
          <el-button :disabled="!cellSelected" type="primary" @click="initAccountTitleHandler">{{ $t('CargoMsg.Cargo_InitializeLevelOneSubject') }}</el-button>
          <el-button :disabled="!cellSelected" type="primary" @click="initStatementDescriptionHandler">{{ $t('CargoMsg.Cargo_InitializeReport') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="min-height: 500px"
        />
      </div>
      <!--根据现有账套新建 弹窗-->
      <account-set-popup
        ref="accountSetPopup"
        :visible.sync="accountSetPopupVisible"
        mode="tenant"
        @select="selectAccountSetHandler"
        @cancel="accountSetPopupVisible=false"
        @accountingSelect="accountingSelectHandler"
      />
      <!--新增/编辑 弹窗-->
      <el-dialog
        id="app"
        :title="editDialog.title"
        :visible.sync="editDialog.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="420px"
      >
        <div style="width: 400px;">
          <el-form ref="form" :model="editDialog.form">
            <el-form-item label-width="0" style="margin-bottom: 2px !important;">
              <div style="display: inline-block;width: 110px;margin-right: 20px;text-align: right">
                <span>{{ $t('CargoMsg.Cargo_Company') }}</span>
                <span style="color: red">*</span>
              </div>
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Office"
                :default-value="editDialog.form.branchId"
                style="display: inline-block;width: 260px"
                filterable
                @parentCallBack="office=>editDialog.form.branchId=office.officeId"
              />
            </el-form-item>
            <el-form-item label-width="0" style="margin-bottom: 2px !important;">
              <div style="display: inline-block;width: 110px;margin-right: 20px;text-align: right">
                <span>{{ $t('CargoMsg.Cargo_SobName') }}</span>
                <span style="color: red">*</span>
              </div>
              <el-input v-model="editDialog.form.name" style="display: inline-block;width: 260px" />
            </el-form-item>
            <el-form-item label-width="0" style="margin-bottom: 2px !important;">
              <div style="display: inline-block;width: 110px;margin-right: 20px;text-align: right">
                <span>{{ $t('CargoMsg.Cargo_SobCode') }}</span>
                <span style="color: red">*</span>
              </div>
              <el-input v-model="editDialog.form.code" style="display: inline-block;width: 260px" />
            </el-form-item>
            <el-form-item label-width="0" style="margin-bottom: 2px !important;">
              <div style="display: inline-block;width: 110px;margin-right: 20px;text-align: right">
                <span>{{ $t('CargoMsg.Cargo_AccountingOrganizationCode') }}</span>
              </div>
              <el-input v-model="editDialog.form.accountingOrganization" style="display: inline-block;width: 260px" />
            </el-form-item>
            <el-form-item label-width="0" style="margin-bottom: 2px !important;">
              <div style="display: inline-block;width: 110px;margin-right: 20px;text-align: right">
                <span>{{ $t('CargoMsg.Cargo_AccountTitleClassificationRule') }}</span>
                <span style="color: red">*</span>
              </div>
              <el-input-number v-model="editDialog.form.accountTitleGradeRule" :controls="false" style="display: inline-block;width: 260px" />
            </el-form-item>
            <el-form-item label-width="0" style="margin-bottom: 2px !important;">
              <div style="display: inline-block;width: 110px;margin-right: 20px;text-align: right">
                <span>{{ $t('CargoMsg.Cargo_StartDateOfFinancialPeriod') }}</span>
                <span style="color: red">*</span>
              </div>
              <el-input-number v-model="editDialog.form.periodBeginDay" controls-position="right" style="display: inline-block;width: 260px" />
            </el-form-item>
            <el-form-item label-width="130px" style="margin-bottom: 2px !important;">
              <div style="width: 260px;">
                <el-checkbox
                  id="dealingsCustomer"
                  v-model="editDialog.form.dealingsCustomer"
                  style="width: 100%; line-height: 1.4; white-space: normal; word-break: break-word;"
                >{{ $t('CargoMsg.Cargo_DealingsCustomer') }}
                </el-checkbox>
              </div>
            </el-form-item>
            <el-form-item label-width="130px" style="margin-bottom: 2px !important;">
              <div style="width: 260px;">
                <el-checkbox
                  id="dealingsCustomer"
                  v-model="editDialog.form.passExceptionExport"
                  style="width: 100%; line-height: 1.4; white-space: normal; word-break: break-word;"
                >{{ $t('CargoMsg.Cargo_AllowsExceptionProofExport') }}
                </el-checkbox>
              </div>
            </el-form-item>
            <el-form-item label-width="120px" style="margin-top: 10px;margin-bottom: 2px !important;">
              <span slot="label">
                <span>{{ $t('CargoMsg.Cargo_SoftwareVersion') }}</span>
                <span style="color: red">*</span>
              </span>
              <div class="verticalEffect" style="height: 240px;width: 260px;margin-left: 10px;">
                <el-radio-group v-for="item in softwareConfigList" :key="item.id" v-model="editDialog.form.softwareVersions" @change="versionChangeHandler">
                  <el-radio :label="item.code" style="width: 240px;">{{ item.name }}</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_InterfaceScheme')" label-width="130px" style="margin-top: 10px;">
              <div class="verticalEffect" style="height: 50px;">
                <el-radio-group v-for="item in softwareSchemes" :key="item.code" v-model="editDialog.form.interfaceScheme">
                  <el-radio :label="item.code">{{ item.name }}</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
          <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!--初始化一级科目/初始化报表 弹窗-->
      <el-dialog
        :title="initDialog.title"
        :visible.sync="initDialog.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        style="width: 50%;"
      >
        <div style="width: 300px;">
          <el-form>
            <el-form-item>
              <span style="color:#CC6666;">{{ $t('FinanceManage.PleaseFinancialYearForReport') }}</span>
            </el-form-item>
            <el-form-item>
              <span style="color:#CC6666;">{{ $t('FinanceManage.RepeatingDataLossPleaseCaution') }}</span>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Financial_Year')">
              <el-input-number v-model="initDialog.year" :controls="false" :min="2000" :max="2099" />
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="initDialogSaveHandler">{{ $t('common.btn.ok') }}</el-button>
          <el-button @click="initDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import * as accountSetApi from '@/api/financeManage/accountSet'
import { getLoading } from '@/utils/utilBaseElement'
import * as financeSoftwareConfigApi from '@/api/financeManage/financeSoftwareConfig'
import * as voucherTypes from '@/class/cargo/model/parameters/VoucherType'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import DateUtils from '@/utils/dateUtils'
import * as statementDescriptionApi from '@/api/financeManage/statementDescription'
import * as accountTitleApi from '@/api/financeManage/accountTitle'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'Ledger',
  components: { cargoCompanySelect, AccountSetPopup, cargoAdvanceSelect },
  props: {
    accountSet: { type: Object, default: null },
    accountSets: { type: Array, default: null }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      accountSetPopupVisible: false,
      cellSelected: false, // 是否选中行
      editDialog: {
        visible: false,
        title: '',
        form: {
          branchId: 0,
          name: '',
          code: '',
          accountingOrganization: '',
          accountTitleGradeRule: '',
          periodBeginDay: '',
          softwareVersions: '',
          interfaceScheme: ''
        }
      },
      initDialog: {
        visible: false,
        title: '',
        type: '',
        year: DateUtils.customFormat(new Date(), 'YYYY')
      },
      softwareConfigList: [],
      softwareSchemes: [],
      currentState: 'read', // read|edit|add
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowClicked: (event) => { this.cellSelected = true; this.selectedItem = event.data }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Company'),
          field: 'branchCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_SobName'),
          field: 'name',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SobCode'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountingOrganizationCode'),
          field: 'accountingOrganization',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleClassificationRule'),
          field: 'accountTitleGradeRule',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_FinancialSoftware'),
          field: 'softwareVersionsName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_InterfaceScheme'),
          field: 'interfaceSchemeName',
          width: 100
        }
      ],
      rowData: [],
      selectedItem: null // 表格选中项
    }
  },
  async created() {
    this.softwareConfigList = await financeSoftwareConfigApi.queryAll().then(resp => resp.data)
    this.loadData()
  },
  methods: {
    addForExistAccountSet() {
      this.accountSetPopupVisible = true
    },
    selectAccountSetHandler(accountSet) {
      console.log(accountSet)
      console.log(this.$refs.accountSetPopup.txtAccountSetName)
      console.log(this.$refs.accountSetPopup.txtCode)
      this.accountSetSelectedHandler('select', accountSet)
    },
    accountSetSelectedHandler(eventName, obj) {
      if (!this.$refs.accountSetPopup.txtAccountSetName) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseEnterSobName'))
        return
      }
      let fiscalPeriod = null
      if (eventName === 'accountingSelect') {
        fiscalPeriod = obj
      }
      const accountSet = this.$refs.accountSetPopup.accountSet
      const params = {}
      params.sourceUuid = accountSet.uuid
      params.name = this.$refs.accountSetPopup.txtAccountSetName
      params.code = this.$refs.accountSetPopup.txtCode
      params.fiscalPeriod = fiscalPeriod
      params.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading()
      accountSetApi.createFromExist(params).then(resp => {
        this.accountSetPopupVisible = false
        this.refreshHandler()
      }).finally(() => loading.close())
    },
    // 新增/编辑 按钮事件
    async showEditDialog(isEdit) {
      if (isEdit) {
        const cell = this.gridOptions.api.getFocusedCell()
        // const currentRow = cell ? this.rowData[cell.rowIndex] : null
        const currentRow = cell ? this.selectedItem : null
        if (!currentRow) {
          this.$message.error(this.$t('common.tips.hasOneAtleast'))
          return
        }
        const row = await accountSetApi.detail({ uuid: currentRow.uuid }).then(resp => resp.data)
        Object.assign(currentRow, row)
        this.editDialog.form = JSON.parse(JSON.stringify(currentRow))
        this.versionChangeHandler(currentRow.softwareVersions, currentRow.interfaceScheme)
      } else {
        // 新增
        const accountSet = this.initForm()
        accountSet.periodBeginDay = 1
        accountSet.summarySeparator = '#'
        this.editDialog.form = accountSet
      }
      this.editDialog.title = isEdit ? this.$t('CargoMsg.Cargo_Edit') : this.$t('CargoMsg.Cargo_Add')
      this.editDialog.visible = true
    },
    // 新增/编辑对话框 保存 按钮事件
    saveHandler() {
      if (!this.validate()) return
      if (!this.editDialog.form.uuid) {
        // 保存关联信息
        const accountingDocumentTypes = []
        const financeCodeMappings = []
        for (const type of voucherTypes.VOUCHER_TYPES) {
          const accountingDocumentType = {}
          accountingDocumentType.code = type['code']
          accountingDocumentType.name = type['name']
          accountingDocumentType.remarks = type['instruction']
          accountingDocumentType.prefix = type['word']
          accountingDocumentTypes.push(accountingDocumentType)

          const financeCodeMapping = {}
          financeCodeMapping.baseDataType = FinanceInterfaceConstants.MAPPING_PREFIX.code
          financeCodeMapping.codeMappingType = 0
          financeCodeMapping.baseDataValue = type['code']
          financeCodeMapping.financeCode = type['word']
          financeCodeMappings.push(financeCodeMapping)
        }
        this.editDialog.form.accountingDocumentTypes = accountingDocumentTypes
        this.editDialog.form.financeCodeMappings = financeCodeMappings
      }
      const loading = getLoading()
      accountSetApi.checkAccountSetCode({ code: this.editDialog.form.code }).then(resp => {
        if (!resp.data) {
          this.codeCheckSuccess()
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_DuplicatedCode'))
        }
      }).finally(() => loading.close())
    },
    codeCheckSuccess() {
      accountSetApi.save(this.editDialog.form).then(resp => {
        // const index = this.rowData.findIndex(row => row === this.editDialog.form)
        // if (index > -1) {
        //   const row = this.rowData[index]
        //   Object.assign(row, resp.data)
        // } else {
        //   this.rowData.push(resp.data)
        // }
        this.editDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
        // 刷新
        this.refreshHandler()
      })
      this.gridOptions.api.refreshCells({ force: true })
    },
    // 刷新 按钮事件
    refreshHandler() {
      this.loadData()
    },
    // 列表数据加载
    loadData() {
      const params = {}
      // params.uuid = this.accountSet.uuid
      params.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading()
      accountSetApi.query(params).then(reps => {
        this.rowData = reps.data.list
      }).finally(() => loading.close())
      this.gridOptions.api.clearFocusedCell()
      this.cellSelected = false
      this.selectedItem = null
    },
    // 删除 按钮事件
    async removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedItem : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_STDTSRRAVWBDT'), this.$t('common.tips.prompt'), { closeOnClickModal: false })
      const loading = getLoading()
      accountSetApi.remove({ uuid: currentRow.uuid }).then(resp => {
        this.removeSuccess(currentRow.uuid)
      }).finally(() => loading.close())
    },
    initForm() {
      return {
        branchId: 0,
        name: '',
        code: '',
        accountingOrganization: '',
        accountTitleGradeRule: '',
        periodBeginDay: '',
        softwareVersions: '',
        interfaceScheme: '',
        dealingsCustomer: true,
        passExceptionExport: false
      }
    },
    // 财务软件变更处理
    versionChangeHandler(code, interfaceScheme) {
      this.softwareSchemes = []
      const config = this.softwareConfigList.find(config => config.code === code)
      if (config && config.schemes) {
        const schemes = JSON.parse(config.schemes)
        this.softwareSchemes = schemes || []
        if (this.softwareSchemes.length > 0) {
          this.editDialog.form.interfaceScheme = interfaceScheme || this.softwareSchemes[0].code
        }
      }
    },
    // 初始化一级科目 按钮事件
    initAccountTitleHandler() {
      this.showInitDialog('initAccountTitle')
    },
    // 初始化报表 按钮事件
    initStatementDescriptionHandler() {
      this.showInitDialog('initStatementDescription')
    },
    // 显示初始化一级科目/初始化报表对话框
    showInitDialog(val) {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedItem : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.initDialog.type = val
      if (val === 'initAccountTitle') {
        this.initDialog.title = this.$t('CargoMsg.Cargo_InitializeLevelOneSubject')
      } else if (val === 'initStatementDescription') {
        this.initDialog.title = this.$t('CargoMsg.Cargo_InitializeReport')
      }
      this.initDialog.year = DateUtils.customFormat(new Date(), 'YYYY')
      this.initDialog.visible = true
    },
    // 初始化一级科目/初始化报表对话框保存 按钮事件
    async initDialogSaveHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedItem : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const params = {}
      params.year = this.initDialog.year
      params.accountSetUuid = currentRow.uuid
      const loading = getLoading()
      if (this.initDialog.type === 'initAccountTitle') {
        await accountTitleApi.initialize(params).then(resp => {
          this.$message.success(this.$t('FinanceManage.InitializationPleaseCheckAccountSettings'))
          this.initDialog.visible = false
        }).finally(() => loading.close())
      } else if (this.initDialog.type === 'initStatementDescription') {
        await statementDescriptionApi.initialize(params).then(resp => {
          this.$message.success(this.$t('FinanceManage.InitializationPleaseCheckTheReport'))
          this.initDialog.visible = false
        }).finally(() => loading.close())
      } else {
        loading.close()
      }
    },
    removeSuccess(uuid) {
      const index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
      }
      this.$message.success(this.$t('Message.DeleteSuccessfully'))
    },
    accountingSelectHandler(obj) {
      this.accountSetSelectedHandler('accountingSelect', obj)
    },
    validate() {
      if (!this.editDialog.form.branchId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Company'))
        return false
      }

      if (StrUtils.isEmpty(this.editDialog.form.name)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterSobName'))
        return false
      }

      if (StrUtils.isEmpty(this.editDialog.form.code)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterSobCode'))
        return false
      }

      if (StrUtils.isEmpty(this.editDialog.form.softwareVersions)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSVOFS'))
        return false
      }

      if (StrUtils.isEmpty(this.editDialog.form.accountTitleGradeRule)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_AccountTitleClassificationRule'))
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.verticalEffect {
  display: flex;
  overflow-y:auto;
  flex-direction:column;
  .el-radio__label {
    font-size: 13px !important;
  }
}
</style>
